require("../../libs/backbone/backbone.ajaxq.adapter.ts");
var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../templates/glazing_building_table.template.html');
var RowElement = require('text-loader!../templates/row_glazing_building.template.html');

var TheView = GenericView.extend({
    el: '#glazing_table_container',
    tagName: 'div',
    template: Handlebars.compile(Template),
	rowElement: Handlebars.compile(RowElement),
	superInitialize: GenericView.prototype.initialize,
	initialize: function (options) {
		var self = this;

		this.render();
		$(window).off("change-building-rows").on("change-building-rows", function() {
		    self.fillOpaqueElementNumbers();
		});
	},
	superRender: GenericView.prototype.render,
	render: function () {
		var self = this;
		this.superRender();
		this.$el.html(this.template);
        this.addRow();
	},
	events: {
		"click #add_glazing_button": "addRow",
		"click #delete_glazing_button": "deleteRow"
	},
	addRow: function()
	{
		$("#glazing_building_elements").append(this.rowElement());

		var opaque_rows = $("#opaqueBuilding tbody tr").length;
		var lastSelect = $("#glazingBuilding tbody").children().last().find(".opaque_element_number");
		this.fillSelect(opaque_rows, lastSelect);
	},
	deleteRow: function(event)
	{
	    var row = $(event.currentTarget);
	    row.parent().parent().remove();
	},
    fillOpaqueElementNumbers: function() {
        var self = this;
        var opaque_rows = $("#opaqueBuilding tbody tr").length;

        $.each($(".opaque_element_number"), function() {
            self.fillSelect(opaque_rows, $(this));
        });
    },
    fillSelect: function(opaque_rows, currentSelect) {
        currentSelect.empty();
        currentSelect.append("<option selected='selected' disabled>Select</option>");
        for (var i=0; i<opaque_rows; i++) {
            currentSelect.append("<option value='"+ (i+1) +"'>" + (i+1) + "</option>");
        }
    },
	clearView: function()
	{
		this.$el.html("");
	}
});

module.exports = TheView;